import type { IExercise } from '../exercises';

export const ARCHIVED_STRETCH_TEACHINGS: IExercise[] = [
  {
    "id": "side-lunge-stretch",
    "name": "侧弓步动态拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "leg-stretch",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/gifs/side-lunge-stretch",
    "videoUrl": "/media/videos/side-lunge-stretch",
  },
  {
    "id": "home-worlds-greatest-stretch",
    "name": "世界最伟大拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "full-stretch",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 2,
    "reps": "每侧5",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/gifs/home-worlds-greatest-stretch",
    "videoUrl": "/media/videos/home-worlds-greatest-stretch",
  },
  {
    "id": "personal-s1-levator-scap-stretch",
    "name": "肩胛提肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["侧屈+旋转组合拉伸","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-levator-scap-stretch",
    "videoUrl": "/media/videos/personal-s1-levator-scap-stretch",
  },
  {
    "id": "personal-s1-sternocleidomastoid",
    "name": "胸锁乳突肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["动作缓慢，感受颈部前侧肌肉延展","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-sternocleidomastoid",
    "videoUrl": "/media/videos/personal-s1-sternocleidomastoid",
  },
  {
    "id": "personal-s1-scalene-release",
    "name": "斜角肌松解",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["用指腹轻柔按压松解","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-scalene-release",
    "videoUrl": "/media/videos/personal-s1-scalene-release",
  },
  {
    "id": "personal-s1-platysma-stretch",
    "name": "颈阔肌拉伸",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "neck",
    "tips": ["仰头伸展颈部前侧","保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-platysma-stretch",
    "videoUrl": "/media/videos/personal-s1-platysma-stretch",
  },
  {
    "id": "fanjue-stretch-counter",
    "name": "拉伸对抗",
    "bodyPart": "stretch",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["拉伸与对抗交替","增加关节活动度"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-stretch-counter",
    "videoUrl": "/media/videos/fanjue-stretch-counter",
  },
];
